import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const RefreshIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7.7929V6.00001C8.69 6.00001 6 8.69001 6 12C6 12.7363 6.13285 13.4459 6.37917 14.0981C6.54107 14.5267 6.47781 15.0222 6.15384 15.3462C5.68515 15.8149 4.89897 15.7273 4.63828 15.1179C4.22917 14.1615 4 13.1082 4 12C4 7.58001 7.58 4.00001 12 4.00001V2.20712C12 1.76167 12.5386 1.53858 12.8536 1.85356L15.6464 4.64646C15.8417 4.84172 15.8417 5.1583 15.6464 5.35356L12.8536 8.14646C12.5386 8.46144 12 8.23836 12 7.7929ZM17.8411 8.65894C18.3124 8.18764 19.103 8.27574 19.3646 8.88878C19.7719 9.84337 20 10.8944 20 12C20 16.42 16.42 20 12 20V21.7929C12 22.2383 11.4614 22.4614 11.1464 22.1465L8.35355 19.3536C8.15829 19.1583 8.15829 18.8417 8.35355 18.6465L11.1464 15.8536C11.4614 15.5386 12 15.7617 12 16.2071V18C15.31 18 18 15.31 18 12C18 11.2605 17.8606 10.5532 17.6132 9.8976C17.4525 9.47169 17.5192 8.98083 17.8411 8.65894Z"
      />
    </Icon>
  );
};
